import { useEffect } from "react";

// Keep a lender's open application profile in sync with support's changes.
export default function usePropertyApplicationCommentRefresh(
  applicationId,
  active,
  token,
  onComments,
) {
  useEffect(() => {
    if (!active || !applicationId) return;
    let disposed = false;
    let pending = false;
    const controller = new AbortController();
    const refresh = async () => {
      if (pending || document.visibilityState === "hidden") return;
      pending = true;
      try {
        const response = await fetch(
          `https://www.smart-lend.com/api/propTermLoan/${applicationId}/support-comments`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
            signal: controller.signal,
          },
        );
        if (disposed) return;
        if (response.status === 403 || response.status === 404) onComments([]);
        else if (response.ok) {
          const body = await response.json();
          if (!disposed)
            onComments(Array.isArray(body.comments) ? body.comments : []);
        }
      } catch (error) {
        // Keep the last successful result while temporarily offline.
      } finally {
        pending = false;
      }
    };
    refresh();
    const timer = setInterval(refresh, 15000);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      disposed = true;
      controller.abort();
      clearInterval(timer);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [applicationId, active, token, onComments]);
}
